import { useEffect } from 'react'

const MetaTags = ({ 
  title = 'سبحات - نخبة المسابيح', 
  description = 'نقدم لكم أجود أنواع المسابيح والسبح بأفضل الأسعار. جودة عالية وخدمة متميزة.',
  keywords = 'مسابيح، سبح، تسبيح، إسلامي، كويت',
  image = null,
  url = null 
}) => {
  useEffect(() => {
    // Update document title
    document.title = title
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', description)
    } else {
      const meta = document.createElement('meta')
      meta.name = 'description'
      meta.content = description
      document.head.appendChild(meta)
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords)
    } else {
      const meta = document.createElement('meta')
      meta.name = 'keywords'
      meta.content = keywords
      document.head.appendChild(meta)
    }
    
    // Update Open Graph tags
    const updateOGTag = (property, content) => {
      if (!content) return
      
      let ogTag = document.querySelector(`meta[property="${property}"]`)
      if (ogTag) {
        ogTag.setAttribute('content', content)
      } else {
        const meta = document.createElement('meta')
        meta.setAttribute('property', property)
        meta.content = content
        document.head.appendChild(meta)
      }
    }
    
    updateOGTag('og:title', title)
    updateOGTag('og:description', description)
    updateOGTag('og:type', 'website')
    if (image) updateOGTag('og:image', image)
    if (url) updateOGTag('og:url', url)
    
    // Update Twitter Card tags
    const updateTwitterTag = (name, content) => {
      if (!content) return
      
      let twitterTag = document.querySelector(`meta[name="${name}"]`)
      if (twitterTag) {
        twitterTag.setAttribute('content', content)
      } else {
        const meta = document.createElement('meta')
        meta.name = name
        meta.content = content
        document.head.appendChild(meta)
      }
    }
    
    updateTwitterTag('twitter:card', 'summary_large_image')
    updateTwitterTag('twitter:title', title)
    updateTwitterTag('twitter:description', description)
    if (image) updateTwitterTag('twitter:image', image)
  }, [title, description, keywords, image, url])

  return null
}

export default MetaTags
